import latex from "refractor/latex";
export default latex;